<div class="main-container">
  <div class="container-fluid pt-3 mb-3 pb-3">
    <div class="login">
      <div class="login-section" *ngIf="loginForm">
        <form [formGroup]="loginForm" (submit)="doLogin()" autocomplete="off">
          <div class="login-form">
            <div class="login-logo">
              <img src="../../../assets/images/refresh-logo.svg" alt="" *ngIf="selectedBusiness == 'REFRESH'">
              <img src="../../../assets/images/zones-logo.svg" alt="" *ngIf="selectedBusiness == 'ZONES'">
              <span>Contractor Portal</span>
            </div>
            <h4 class="text-center">Login</h4>
            <div class="row">
              <div class="col-md-12 pb-1">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Email</mat-label>
                  <mat-icon matPrefix>account_circle</mat-icon>
                  <input matInput formControlName="username" type="text" required autocomplete="off" />
                  <mat-error *ngIf="loginForm.get('username')?.hasError('required')">Email is required</mat-error>
                  <mat-error *ngIf="
                      loginForm.get('username')?.hasError('cannotContainSpace')
                    ">White Space is not allowed</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Password</mat-label>
                  <mat-icon matPrefix>lock</mat-icon>
                  <input matInput formControlName="password" [type]="isShow ? 'text' : 'password'" required
                    autocomplete="off" />
                  <mat-icon matSuffix class="eye" (click)="isShow = !isShow">remove_red_eye</mat-icon>
                  <mat-error *ngIf="loginForm?.get('password')?.hasError('required')">Password is required</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6 col-sm-6 col-6">
                <mat-checkbox  formControlName="remember">Remember Me?</mat-checkbox>
              </div>
              <div class="col-md-6 col-sm-6 col-6 text-end">
                <p class="forgot" routerLink="/auth/forgot-password">
                  Forgot Password?
                </p>
              </div>
              <div class="col-md-12 mt-4">
                <button mat-raised-button color="primary" type="submit" class="full-width">
                  Login
                </button>
              </div>
              <div class="col-md-12">
                <div class="separator">
                  <span>Or</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="google" (click)="doGoogleSignIn()">
                  <img src="../../../assets/images/g-logo.png" />
                  <span>Continue with Google</span>
                </div>
              </div>
              <div class="col-md-12">
                <p class="signup-btn">
                  Need an account ?
                  <span (click)="navigateOnSignUp()">SIGN UP</span>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>